import { ComponentPropsWithoutRef } from "react";

export function LocationIcon({
  outline,
  ...props
}: ComponentPropsWithoutRef<"svg"> & { outline?: boolean }) {
  return outline ? (
    <svg
      data-component="LocationIcon"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ) : (
    <svg
      data-component="LocationIcon"
      stroke="currentColor"
      viewBox="0 0 384 512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z" />
    </svg>
  );
}
